module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    class: [
      'd-nav',
      ("d-nav--" + _vm.dashboardTransitionState) ]
  }, [_c('div', {
    staticClass: "d-nav__wrapper"
  }, [_c('div', {
    staticClass: "d-nav__panels"
  }, _vm._l((_vm.panels), function(panel, index) {
    return (_vm.userIsRole(panel.role)) ? _c('div', {
      key: index,
      staticClass: "d-nav__panel"
    }, [_c('p', {
      staticClass: "h6 d-nav__heading",
      domProps: {
        "innerHTML": _vm._s(panel.title)
      }
    }), _vm._v(" "), _c('ul', {
      staticClass: "d-nav__list"
    }, _vm._l((panel.links), function(link, index) {
      return _c('li', {
        key: index,
        staticClass: "p"
      }, [_c('module-link', {
        staticClass: "d-nav__link",
        attrs: {
          "link": link.link
        }
      }, [_vm._v(_vm._s(link.title))])], 1)
    }))]) : _vm._e()
  })), _vm._v(" "), _c('span', {
    staticClass: "p d-nav__logout"
  }, [_c('module-link', {
    staticClass: "dashboard__link",
    attrs: {
      "link": "logout",
      "label": "Log out",
      "icon": "logout",
      "icon-negative": true,
      "no-underline": true
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-76e31f2e"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/pages/dashboard/Navigation.vue
// module id = 328
// module chunks = 0